/**
 * Paquetes en ingles. Misma forma que los espanoles y mismas plantillas, con
 * dos diferencias de gramatica que resuelve el motor y no el paquete: el
 * organo ajeno va en genitivo ("Ana's Heart") y no hay articulos que
 * contraer. Por eso `art` es siempre 'the' y no se usa.
 */
const CONTAGIO_EN = {
    id: 'contagio',
    name: 'Contagio',
    tagline: 'Organs, viruses and medicines. The classic deck.',
    kinds: { organ: 'Organ', virus: 'Virus', medicine: 'Medicine', treatment: 'Treatment' },
    organs: {
        red: { name: 'Heart', art: 'the' },
        blue: { name: 'Brain', art: 'the' },
        green: { name: 'Lung', art: 'the' },
        yellow: { name: 'Liver', art: 'the' },
        wild: { name: 'Chimera Organ', art: 'the' },
    },
    viruses: {
        red: 'Scarlet Strain',
        blue: 'Cobalt Strain',
        green: 'Emerald Strain',
        yellow: 'Amber Strain',
        wild: 'Mutant Strain',
    },
    medicines: {
        red: 'Scarlet Antidote',
        blue: 'Cobalt Antidote',
        green: 'Emerald Antidote',
        yellow: 'Amber Antidote',
        wild: 'Universal Antidote',
    },
    treatments: {
        swap: {
            name: 'Surgical Swap',
            text: 'Swap one of your organs for another player\'s. Neither may be immunized, and nobody can end up with a repeated color.',
        },
        steal: {
            name: 'Illegal Extraction',
            text: 'Take an organ from another player and add it to your body. You cannot steal immunized organs or repeat a color.',
        },
        spread: {
            name: 'Outbreak',
            text: 'Move viruses from your infected organs onto free organs of your rivals.',
        },
        quarantine: {
            name: 'Quarantine',
            text: 'Every rival discards their hand and loses their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Medical Malpractice',
            text: 'Swap your whole body with another player\'s, immunized organs included.',
        },
    },
    hints: {
        organ: 'Place it in your body. One of each color.',
        virus: 'Infects a free organ, removes an infected one or breaks a vaccine.',
        medicine: 'Cures a virus, vaccinates a free organ or immunizes a vaccinated one.',
    },
    stamps: { infected: 'Infected', vaccinated: 'Vaccinated', immunized: 'Immune' },
    words: {
        organ: 'organ',
        organs: 'organs',
        the: 'the',
        one: 'one',
        healthy: 'healthy',
        threat: 'virus',
        threats: 'viruses',
        body: 'body',
    },
    lines: {
        place: '{p} places the {card}.',
        infect: '{p} infects {organ}.',
        remove: '{p} removes {organ}.',
        breakShield: '{p} destroys the vaccine on {organ}.',
        cure: '{p} cures {organ}.',
        vaccinate: '{p} vaccinates {organ}.',
        immunize: '{p} immunizes {organ}.',
        spread: '{p} spreads {n} {threats} to their rivals.',
        quarantine: '{p} declares a quarantine: everyone else discards their hand.',
        malpractice: '{p} swaps their whole body with {victim}.',
        win: '{p} completes a healthy body and wins the game.',
    },
    buttons: { spread: 'Spread {n} {threats}', quarantine: 'Declare quarantine', malpractice: 'Swap bodies' },
    ending: {
        winTitle: 'Body complete. You win.',
        winText: 'Four healthy organs on the table before anyone else.',
        loseTitle: '{p} completes their body.',
        loseText: 'Your organs were left half done. The next round starts from scratch.',
    },
};
const HEROES_EN = {
    id: 'heroes',
    name: 'DC Heroes',
    tagline: 'Batman, Superman and the Flash against their oldest foes.',
    kinds: { organ: 'Hero', virus: 'Villain', medicine: 'Backup', treatment: 'Event' },
    organs: {
        red: { name: 'Flash', art: 'the' },
        blue: { name: 'Superman', art: 'the' },
        green: { name: 'Green Lantern', art: 'the' },
        yellow: { name: 'Batman', art: 'the' },
        wild: { name: 'Wonder Woman', art: 'the' },
    },
    viruses: {
        red: 'Reverse-Flash',
        blue: 'Lex Luthor',
        green: 'Sinestro',
        yellow: 'Joker',
        wild: 'Darkseid',
    },
    medicines: {
        red: 'Speed Force',
        blue: 'Fortress of Solitude',
        green: 'Power Ring',
        yellow: 'Utility Belt',
        wild: 'League Watchtower',
    },
    treatments: {
        swap: {
            name: 'Boom Tube',
            text: 'Open a portal and swap one of your heroes for another player\'s. Neither may be invincible, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Recruitment',
            text: 'Talk another player\'s hero into joining your team. Does not work on invincible heroes, or if you already have one of that color.',
        },
        spread: {
            name: 'Arkham Breakout',
            text: 'The villains holding your heroes break loose and land on your rivals\' free heroes.',
        },
        quarantine: {
            name: 'Phantom Zone',
            text: 'Your rivals lose their hands to the Phantom Zone and spend their next turn drawing new ones.',
        },
        malpractice: {
            name: 'Multiverse Crisis',
            text: 'Swap your whole team with another player\'s, invincible heroes included.',
        },
    },
    hints: {
        organ: 'Add it to your team. One of each color.',
        virus: 'Captures a free hero, defeats a captured one or breaks a protection.',
        medicine: 'Rescues a captured hero, protects a free one or makes a protected one invincible.',
    },
    stamps: { infected: 'Captured', vaccinated: 'Protected', immunized: 'Invincible' },
    words: {
        organ: 'hero',
        organs: 'heroes',
        the: 'the',
        one: 'one',
        healthy: 'standing',
        threat: 'villain',
        threats: 'villains',
        body: 'team',
    },
    lines: {
        place: '{p} adds {card} to their team.',
        infect: '{p} captures {organ}.',
        remove: '{p} defeats {organ}.',
        breakShield: '{p} breaks the protection on {organ}.',
        cure: '{p} rescues {organ}.',
        vaccinate: '{p} protects {organ}.',
        immunize: '{p} makes {organ} invincible.',
        spread: '{p} unleashes {n} {threats} on their rivals.',
        quarantine: '{p} opens the Phantom Zone: everyone else loses their hand.',
        malpractice: '{p} jumps universes with {victim}: teams swapped.',
        win: '{p} assembles their team and wins the game.',
    },
    buttons: { spread: 'Unleash {n} {threats}', quarantine: 'Open the Phantom Zone', malpractice: 'Jump universes' },
    ending: {
        winTitle: 'Team assembled. You win.',
        winText: 'Four heroes standing before anyone else.',
        loseTitle: '{p} assembles their team.',
        loseText: 'Your team was left half formed. The next round starts from scratch.',
    },
    credit: 'The characters in DC Heroes belong to DC Comics; this pack is a non-profit fan tribute.',
};
const MARVEL_EN = {
    id: 'marvel',
    name: 'Marvel Heroes',
    tagline: 'The Avengers against Thanos and company.',
    kinds: { organ: 'Hero', virus: 'Villain', medicine: 'Backup', treatment: 'Event' },
    organs: {
        red: { name: 'Iron Man', art: 'the' },
        blue: { name: 'Captain America', art: 'the' },
        green: { name: 'Hulk', art: 'the' },
        yellow: { name: 'Thor', art: 'the' },
        wild: { name: 'Spider-Man', art: 'the' },
    },
    viruses: {
        red: 'Ultron',
        blue: 'Red Skull',
        green: 'Abomination',
        yellow: 'Loki',
        wild: 'Thanos',
    },
    medicines: {
        red: 'Arc Reactor',
        blue: 'Vibranium Shield',
        green: 'Banner\'s Lab',
        yellow: 'Bifrost',
        wild: 'Avengers Tower',
    },
    treatments: {
        swap: {
            name: 'Quantum Jump',
            text: 'Travel through the Quantum Realm and swap one of your heroes for another player\'s. Neither may be invincible, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Avengers Initiative',
            text: 'Sign another player\'s hero to your team. Does not work on invincible heroes, or if you already have one of that color.',
        },
        spread: {
            name: 'Raft Breakout',
            text: 'The villains holding your heroes break out of prison and land on your rivals\' free heroes.',
        },
        quarantine: {
            name: 'The Snap',
            text: 'One snap and your rivals\' hands turn to dust: they discard them and lose their next turn drawing new ones.',
        },
        malpractice: {
            name: 'Multiversal Incursion',
            text: 'Swap your whole team with another player\'s, invincible heroes included.',
        },
    },
    hints: {
        organ: 'Add it to your team. One of each color.',
        virus: 'Captures a free hero, defeats a captured one or breaks a protection.',
        medicine: 'Rescues a captured hero, protects a free one or makes a protected one invincible.',
    },
    stamps: { infected: 'Captured', vaccinated: 'Protected', immunized: 'Invincible' },
    words: {
        organ: 'hero',
        organs: 'heroes',
        the: 'the',
        one: 'one',
        healthy: 'standing',
        threat: 'villain',
        threats: 'villains',
        body: 'team',
    },
    lines: {
        place: '{p} recruits {card} for the Avengers.',
        infect: '{p} captures {organ}.',
        remove: '{p} defeats {organ}.',
        breakShield: '{p} breaks the protection on {organ}.',
        cure: '{p} rescues {organ}.',
        vaccinate: '{p} protects {organ}.',
        immunize: '{p} makes {organ} invincible.',
        spread: '{p} unleashes {n} {threats} on their rivals.',
        quarantine: '{p} snaps their fingers: everyone else loses their hand.',
        malpractice: '{p} triggers an incursion and swaps teams with {victim}.',
        win: '{p} assembles the Avengers and wins the game.',
    },
    buttons: { spread: 'Unleash {n} {threats}', quarantine: 'Snap your fingers', malpractice: 'Jump universes' },
    ending: {
        winTitle: 'Avengers assembled. You win.',
        winText: 'Four heroes standing before anyone else.',
        loseTitle: '{p} assembles the Avengers.',
        loseText: 'Your team was left half formed. The next round starts from scratch.',
    },
    credit: 'The characters in Marvel Heroes belong to Marvel; this pack is a non-profit fan tribute.',
};
const FRUTAS_EN = {
    id: 'frutas',
    name: 'Fruit Bowl',
    tagline: 'Fresh fruit, pests and preserves. Don\'t let anything go bad.',
    kinds: { organ: 'Fruit', virus: 'Pest', medicine: 'Preserve', treatment: 'Mishap' },
    organs: {
        red: { name: 'Strawberry', art: 'the' },
        blue: { name: 'Blueberry', art: 'the' },
        green: { name: 'Kiwi', art: 'the' },
        yellow: { name: 'Banana', art: 'the' },
        wild: { name: 'Fruit Salad', art: 'the' },
    },
    viruses: {
        red: 'Worm',
        blue: 'Mold',
        green: 'Aphid',
        yellow: 'Fruit Fly',
        wild: 'Ravenous Pest',
    },
    medicines: {
        red: 'Jam',
        blue: 'Compote',
        green: 'Sugar Glaze',
        yellow: 'Syrup',
        wild: 'Fridge',
    },
    treatments: {
        swap: {
            name: 'Barter',
            text: 'Swap one of your fruits for another player\'s. Neither may be preserved, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Sticky Fingers',
            text: 'Snatch another player\'s fruit into your bowl. Does not work on preserved fruit, or if you already have one of that color.',
        },
        spread: {
            name: 'Bad Apple',
            text: 'The pests on your fruits jump onto your rivals\' free fruits.',
        },
        quarantine: {
            name: 'Frost',
            text: 'A frost ruins your rivals\' hands: they discard them and lose their next turn drawing new ones.',
        },
        malpractice: {
            name: 'Stall Swap',
            text: 'Swap your whole fruit bowl with another player\'s, preserves included.',
        },
    },
    hints: {
        organ: 'Put it in your bowl. One of each color.',
        virus: 'Plants a pest on a free fruit, rots an infested one or spoils a protection.',
        medicine: 'Saves an infested fruit, protects a free one or preserves one that was already protected.',
    },
    stamps: { infected: 'Infested', vaccinated: 'Protected', immunized: 'Preserved' },
    words: {
        organ: 'fruit',
        organs: 'fruits',
        the: 'the',
        one: 'one',
        healthy: 'fresh',
        threat: 'pest',
        threats: 'pests',
        body: 'fruit bowl',
    },
    lines: {
        place: '{p} puts the {card} in their bowl.',
        infect: '{p} plants a pest on {organ}.',
        remove: '{p} rots {organ}.',
        breakShield: '{p} strips the protection off {organ}.',
        cure: '{p} saves {organ}.',
        vaccinate: '{p} protects {organ}.',
        immunize: '{p} preserves {organ}.',
        spread: '{p} passes {n} {threats} to their rivals.',
        quarantine: '{p} brings a frost: everyone else loses their hand.',
        malpractice: '{p} swaps stalls with {victim}.',
        win: '{p} fills their bowl and wins the game.',
    },
    buttons: { spread: 'Pass {n} {threats}', quarantine: 'Bring the frost', malpractice: 'Swap stalls' },
    ending: {
        winTitle: 'Bowl full. You win.',
        winText: 'Four fresh fruits on the table before anyone else.',
        loseTitle: '{p} fills their bowl.',
        loseText: 'Your bowl was left half full. The next round starts from scratch.',
    },
};
const CORTAFUEGOS_EN = {
    id: 'cortafuegos',
    name: 'Firewall',
    tagline: 'Servers, malware and patches. Keep the system from going down.',
    kinds: { organ: 'Component', virus: 'Malware', medicine: 'Patch', treatment: 'Command' },
    organs: {
        red: { name: 'Processor', art: 'the' },
        blue: { name: 'Database', art: 'the' },
        green: { name: 'Router', art: 'the' },
        yellow: { name: 'Power Supply', art: 'the' },
        wild: { name: 'Hybrid Cloud', art: 'the' },
    },
    viruses: {
        red: 'Ransomware',
        blue: 'Trojan',
        green: 'Network Worm',
        yellow: 'Power Surge',
        wild: 'Zero-Day',
    },
    medicines: {
        red: 'Kernel Patch',
        blue: 'Backup',
        green: 'Firewall',
        yellow: 'Voltage Regulator',
        wild: 'System Update',
    },
    treatments: {
        swap: {
            name: 'Migration',
            text: 'Swap one of your components for another player\'s. Neither may be encrypted, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Session Hijack',
            text: 'Take control of another player\'s component and add it to your system. Does not work on encrypted components, or if you already have one of that color.',
        },
        spread: {
            name: 'Chain Letter',
            text: 'Forward the attacks on your components to your rivals\' free components.',
        },
        quarantine: {
            name: 'Blackout',
            text: 'The power goes out at every other desk: your rivals discard their hands and lose their next turn drawing new ones.',
        },
        malpractice: {
            name: 'Disk Clone',
            text: 'Swap your whole system with another player\'s, encrypted components included.',
        },
    },
    hints: {
        organ: 'Install it in your system. One of each color.',
        virus: 'Hacks a free component, takes down a hacked one or blows a patch.',
        medicine: 'Cleans a hacked component, patches a free one or encrypts a patched one.',
    },
    stamps: { infected: 'Hacked', vaccinated: 'Patched', immunized: 'Encrypted' },
    words: {
        organ: 'component',
        organs: 'components',
        the: 'the',
        one: 'one',
        healthy: 'online',
        threat: 'attack',
        threats: 'attacks',
        body: 'system',
    },
    lines: {
        place: '{p} installs the {card}.',
        infect: '{p} hacks {organ}.',
        remove: '{p} takes down {organ}.',
        breakShield: '{p} blows the patch on {organ}.',
        cure: '{p} cleans {organ}.',
        vaccinate: '{p} patches {organ}.',
        immunize: '{p} encrypts {organ}.',
        spread: '{p} forwards {n} {threats} to their rivals.',
        quarantine: '{p} triggers a blackout: everyone else loses their hand.',
        malpractice: '{p} clones their disk with {victim}: systems swapped.',
        win: '{p} brings their whole system online and wins the game.',
    },
    buttons: { spread: 'Forward {n} {threats}', quarantine: 'Trigger a blackout', malpractice: 'Clone disk' },
    ending: {
        winTitle: 'System online. You win.',
        winText: 'Four components online before anyone else.',
        loseTitle: '{p} brings their system online.',
        loseText: 'Your system was left half built. The next round starts from scratch.',
    },
};
const ORBITA_EN = {
    id: 'orbita',
    name: 'Orbit',
    tagline: 'A space station, breakdowns and repairs against the clock.',
    kinds: { organ: 'Module', virus: 'Fault', medicine: 'Repair', treatment: 'Maneuver' },
    organs: {
        red: { name: 'Reactor', art: 'the' },
        blue: { name: 'Life Support', art: 'the' },
        green: { name: 'Greenhouse', art: 'the' },
        yellow: { name: 'Solar Panel', art: 'the' },
        wild: { name: 'Prototype Module', art: 'the' },
    },
    viruses: {
        red: 'Plasma Leak',
        blue: 'Oxygen Leak',
        green: 'Spore Blight',
        yellow: 'Solar Storm',
        wild: 'Meteor',
    },
    medicines: {
        red: 'Coolant',
        blue: 'Hull Seal',
        green: 'Fumigation',
        yellow: 'Magnetic Shield',
        wild: 'Maintenance Bot',
    },
    treatments: {
        swap: {
            name: 'Docking',
            text: 'Swap one of your modules for one of another player\'s. Neither may be armored, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Robotic Arm',
            text: 'Rip a module off another station and dock it to yours. Does not work on armored modules or if you already have one of that color.',
        },
        spread: {
            name: 'Chain Reaction',
            text: 'The faults on your modules jump to free modules of your rivals.',
        },
        quarantine: {
            name: 'Electromagnetic Pulse',
            text: 'A pulse fries your rivals\' controls: they discard their hand and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Orbit Swap',
            text: 'Swap your whole station with another player\'s, armored modules included.',
        },
    },
    hints: {
        organ: 'Dock it to your station. One per color.',
        virus: 'Damages a free module, destroys a damaged one or breaks a reinforcement.',
        medicine: 'Fixes a fault, reinforces a free module or armors a reinforced one.',
    },
    stamps: { infected: 'Damaged', vaccinated: 'Reinforced', immunized: 'Armored' },
    words: {
        organ: 'module',
        organs: 'modules',
        the: 'the',
        one: 'one',
        healthy: 'working',
        threat: 'fault',
        threats: 'faults',
        body: 'station',
    },
    lines: {
        place: '{p} docks the {card} to their station.',
        infect: '{p} damages {organ}.',
        remove: '{p} destroys {organ}.',
        breakShield: '{p} breaks the reinforcement on {organ}.',
        cure: '{p} repairs {organ}.',
        vaccinate: '{p} reinforces {organ}.',
        immunize: '{p} armors {organ}.',
        spread: '{p} unleashes {n} {threats} on the rival stations.',
        quarantine: '{p} fires an electromagnetic pulse: everyone else loses their hand.',
        malpractice: '{p} swaps orbits with {victim}: stations exchanged.',
        win: '{p} brings their station online and wins the game.',
    },
    buttons: { spread: 'Unleash {n} {threats}', quarantine: 'Fire the pulse', malpractice: 'Swap orbits' },
    ending: {
        winTitle: 'Station online. You win.',
        winText: 'Four working modules before anyone else.',
        loseTitle: '{p} brings their station online.',
        loseText: 'Your station was left half built. The next round starts from scratch.',
    },
};
const ASEDIO_EN = {
    id: 'asedio',
    name: 'Siege',
    tagline: 'Defend your castle while you storm the neighbors\'.',
    kinds: { organ: 'Bastion', virus: 'Assault', medicine: 'Defense', treatment: 'Stratagem' },
    organs: {
        red: { name: 'Armory', art: 'the' },
        blue: { name: 'Well', art: 'the' },
        green: { name: 'Orchard', art: 'the' },
        yellow: { name: 'Treasury', art: 'the' },
        wild: { name: 'Keep', art: 'the' },
    },
    viruses: {
        red: 'Fire',
        blue: 'Poison',
        green: 'Pillage',
        yellow: 'Bribe',
        wild: 'Betrayal',
    },
    medicines: {
        red: 'Bucket Brigade',
        blue: 'Food Taster',
        green: 'Scarecrow',
        yellow: 'Deadbolt',
        wild: 'Rampart',
    },
    treatments: {
        swap: {
            name: 'Treaty',
            text: 'Swap one of your bastions for one of another player\'s. Neither may be impregnable, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Conquest',
            text: 'Take a bastion from another player and add it to your castle. Does not work on impregnable bastions or if you already have one of that color.',
        },
        spread: {
            name: 'Catapult',
            text: 'Hurl the assaults your castle is suffering onto free bastions of your rivals.',
        },
        quarantine: {
            name: 'Blockade',
            text: 'Blockade the rival castles: they discard their hand and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Coup',
            text: 'Swap your whole castle with another player\'s, impregnable bastions included.',
        },
    },
    hints: {
        organ: 'Raise it in your castle. One per color.',
        virus: 'Storms a free bastion, razes a stormed one or topples a defense.',
        medicine: 'Repels an assault, defends a free bastion or makes a defended one impregnable.',
    },
    stamps: { infected: 'Stormed', vaccinated: 'Defended', immunized: 'Unbeaten' },
    words: {
        organ: 'bastion',
        organs: 'bastions',
        the: 'the',
        one: 'one',
        healthy: 'intact',
        threat: 'assault',
        threats: 'assaults',
        body: 'castle',
    },
    lines: {
        place: '{p} raises the {card} in their castle.',
        infect: '{p} storms {organ}.',
        remove: '{p} razes {organ}.',
        breakShield: '{p} topples the defense on {organ}.',
        cure: '{p} repels the assault on {organ}.',
        vaccinate: '{p} defends {organ}.',
        immunize: '{p} makes {organ} impregnable.',
        spread: '{p} hurls {n} {threats} with the catapult.',
        quarantine: '{p} blockades the rival castles: everyone else loses their hand.',
        malpractice: '{p} stages a coup and swaps castles with {victim}.',
        win: '{p} completes their castle and wins the game.',
    },
    buttons: { spread: 'Hurl {n} {threats}', quarantine: 'Blockade castles', malpractice: 'Stage the coup' },
    ending: {
        winTitle: 'Castle standing. You win.',
        winText: 'Four intact bastions before anyone else.',
        loseTitle: '{p} completes their castle.',
        loseText: 'Your castle was left half built. The next round starts from scratch.',
    },
};
const ARRECIFE_EN = {
    id: 'arrecife',
    name: 'Reef',
    tagline: 'Sea creatures, spills and rescues under the waves.',
    kinds: { organ: 'Creature', virus: 'Threat', medicine: 'Rescue', treatment: 'Tide' },
    organs: {
        red: { name: 'Crab', art: 'the' },
        blue: { name: 'Whale', art: 'the' },
        green: { name: 'Turtle', art: 'the' },
        yellow: { name: 'Pufferfish', art: 'the' },
        wild: { name: 'Mimic Octopus', art: 'the' },
    },
    viruses: {
        red: 'Fishhook',
        blue: 'Oil Slick',
        green: 'Toxic Algae',
        yellow: 'Plastic',
        wild: 'Chemical Spill',
    },
    medicines: {
        red: 'Fishing Ban',
        blue: 'Beach Cleanup',
        green: 'Sea Nursery',
        yellow: 'Trash Net',
        wild: 'Marine Reserve',
    },
    treatments: {
        swap: {
            name: 'Symbiosis',
            text: 'Swap one of your creatures for one of another player\'s. Neither may be off-limits, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Migration',
            text: 'A creature from another player migrates to your reef. Does not work on off-limits creatures or if you already have one of that color.',
        },
        spread: {
            name: 'Current',
            text: 'The current carries the threats on your creatures to free creatures of your rivals.',
        },
        quarantine: {
            name: 'Squall',
            text: 'A squall sweeps away your rivals\' hands: they discard them and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Tsunami',
            text: 'Swap your whole reef with another player\'s, off-limits creatures included.',
        },
    },
    hints: {
        organ: 'Bring it to your reef. One per color.',
        virus: 'Endangers a free creature, wipes out an endangered one or undoes a protection.',
        medicine: 'Rescues an endangered creature, protects a free one or makes a protected one off-limits.',
    },
    stamps: { infected: 'Endangered', vaccinated: 'Protected', immunized: 'Off-limits' },
    words: {
        organ: 'creature',
        organs: 'creatures',
        the: 'the',
        one: 'one',
        healthy: 'safe',
        threat: 'threat',
        threats: 'threats',
        body: 'reef',
    },
    lines: {
        place: '{p} brings the {card} to their reef.',
        infect: '{p} endangers {organ}.',
        remove: '{p} wipes out {organ}.',
        breakShield: '{p} strips the protection from {organ}.',
        cure: '{p} rescues {organ}.',
        vaccinate: '{p} protects {organ}.',
        immunize: '{p} makes {organ} off-limits.',
        spread: '{p} sweeps {n} {threats} over to their rivals.',
        quarantine: '{p} whips up a squall: everyone else loses their hand.',
        malpractice: '{p} sets off a tsunami and swaps reefs with {victim}.',
        win: '{p} makes their reef safe and wins the game.',
    },
    buttons: { spread: 'Sweep {n} {threats}', quarantine: 'Whip up the squall', malpractice: 'Swap reefs' },
    ending: {
        winTitle: 'Reef safe. You win.',
        winText: 'Four safe creatures before anyone else.',
        loseTitle: '{p} makes their reef safe.',
        loseText: 'Your reef was left half done. The next round starts from scratch.',
    },
};
const GRIMORIO_EN = {
    id: 'grimorio',
    name: 'Grimoire',
    tagline: 'Four elements, curses and the runes that break them.',
    kinds: { organ: 'Element', virus: 'Curse', medicine: 'Rune', treatment: 'Spell' },
    organs: {
        red: { name: 'Fire', art: 'the' },
        blue: { name: 'Water', art: 'the' },
        green: { name: 'Forest', art: 'the' },
        yellow: { name: 'Lightning', art: 'the' },
        wild: { name: 'Aether', art: 'the' },
    },
    viruses: {
        red: 'Ash',
        blue: 'Black Mist',
        green: 'Wither',
        yellow: 'Static',
        wild: 'Void',
    },
    medicines: {
        red: 'Ember Rune',
        blue: 'Tide Rune',
        green: 'Root Rune',
        yellow: 'Thunder Rune',
        wild: 'Master Rune',
    },
    treatments: {
        swap: {
            name: 'Transmutation',
            text: 'Swap one of your elements for one of another player\'s. Neither may be sealed, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Summoning',
            text: 'Summon an element from another player into your grimoire. Does not work on sealed elements or if you already have one of that color.',
        },
        spread: {
            name: 'Hex',
            text: 'The curses on your elements leap to free elements of your rivals.',
        },
        quarantine: {
            name: 'Silence',
            text: 'A silence spell wipes your rivals\' hands: they discard them and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Arcane Mirror',
            text: 'Swap your whole grimoire with another player\'s, sealed elements included.',
        },
    },
    hints: {
        organ: 'Write it into your grimoire. One per color.',
        virus: 'Curses a free element, banishes a cursed one or erases a rune.',
        medicine: 'Breaks a curse, engraves a rune on a free element or seals it if it already has one.',
    },
    stamps: { infected: 'Cursed', vaccinated: 'Engraved', immunized: 'Sealed' },
    words: {
        organ: 'element',
        organs: 'elements',
        the: 'the',
        one: 'one',
        healthy: 'pure',
        threat: 'curse',
        threats: 'curses',
        body: 'grimoire',
    },
    lines: {
        place: '{p} writes the {card} into their grimoire.',
        infect: '{p} curses {organ}.',
        remove: '{p} banishes {organ}.',
        breakShield: '{p} erases the rune on {organ}.',
        cure: '{p} breaks the curse on {organ}.',
        vaccinate: '{p} engraves a rune on {organ}.',
        immunize: '{p} seals {organ}.',
        spread: '{p} casts {n} {threats} on their rivals.',
        quarantine: '{p} casts a silence: everyone else loses their hand.',
        malpractice: '{p} steps through the arcane mirror and swaps grimoires with {victim}.',
        win: '{p} completes their grimoire and wins the game.',
    },
    buttons: { spread: 'Cast {n} {threats}', quarantine: 'Cast silence', malpractice: 'Enter the mirror' },
    ending: {
        winTitle: 'Grimoire complete. You win.',
        winText: 'Four pure elements before anyone else.',
        loseTitle: '{p} completes their grimoire.',
        loseText: 'Your grimoire was left half written. The next round starts from scratch.',
    },
};
const JURASICO_EN = {
    id: 'jurasico',
    name: 'Jurassic',
    tagline: 'Dinosaurs, volcanoes and a herd that refuses to go extinct.',
    kinds: { organ: 'Dinosaur', virus: 'Hazard', medicine: 'Shelter', treatment: 'Phenomenon' },
    organs: {
        red: { name: 'Tyrannosaurus', art: 'the' },
        blue: { name: 'Pterodactyl', art: 'the' },
        green: { name: 'Diplodocus', art: 'the' },
        yellow: { name: 'Triceratops', art: 'the' },
        wild: { name: 'Mystery Egg', art: 'the' },
    },
    viruses: {
        red: 'Lava',
        blue: 'Ice Age',
        green: 'Swamp',
        yellow: 'Drought',
        wild: 'Meteor',
    },
    medicines: {
        red: 'Cave',
        blue: 'Plumage',
        green: 'Fern Grove',
        yellow: 'Oasis',
        wild: 'Herd Instinct',
    },
    treatments: {
        swap: {
            name: 'Herd Crossing',
            text: 'Swap one of your dinosaurs for one of another player\'s. Neither may be invincible, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Territory Grab',
            text: 'Invade another player\'s territory and one of their dinosaurs joins your herd. Does not work on invincible dinosaurs, or if you already have one of that color.',
        },
        spread: {
            name: 'Eruption',
            text: 'The hazards on your dinosaurs blow up and rain down on your rivals\' free dinosaurs.',
        },
        quarantine: {
            name: 'Roar',
            text: 'A roar scares off your rivals: they drop their hand and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Continental Drift',
            text: 'Swap your whole herd with another player\'s, invincible dinosaurs included.',
        },
    },
    hints: {
        organ: 'Bring it into your herd. One of each color.',
        virus: 'Corners a free dinosaur, wipes out a cornered one or destroys a shelter.',
        medicine: 'Saves a cornered dinosaur, shelters a free one or makes a sheltered one invincible.',
    },
    stamps: { infected: 'Cornered', vaccinated: 'Sheltered', immunized: 'Invincible' },
    words: {
        organ: 'dinosaur',
        organs: 'dinosaurs',
        the: 'the',
        one: 'one',
        healthy: 'living',
        threat: 'hazard',
        threats: 'hazards',
        body: 'herd',
    },
    lines: {
        place: '{p} adds the {card} to their herd.',
        infect: '{p} corners {organ}.',
        remove: '{p} wipes out {organ}.',
        breakShield: '{p} destroys the shelter of {organ}.',
        cure: '{p} saves {organ}.',
        vaccinate: '{p} shelters {organ}.',
        immunize: '{p} makes {organ} invincible.',
        spread: '{p} unleashes {n} {threats} on their rivals.',
        quarantine: '{p} lets out a roar: everyone else drops their hand.',
        malpractice: '{p} sets off continental drift and swaps herds with {victim}.',
        win: '{p} gathers their herd and wins the game.',
    },
    buttons: { spread: 'Unleash {n} {threats}', quarantine: 'Roar', malpractice: 'Drift continents' },
    ending: {
        winTitle: 'Herd complete. You win.',
        winText: 'Four living dinosaurs before anyone else.',
        loseTitle: '{p} gathers their herd.',
        loseText: 'Your herd was left half-formed. The next round starts from scratch.',
    },
};
const BANDA_EN = {
    id: 'banda',
    name: 'The Band',
    tagline: 'Instruments, sour notes and one last rehearsal before the gig.',
    kinds: { organ: 'Instrument', virus: 'Noise', medicine: 'Tuning', treatment: 'Stage' },
    organs: {
        red: { name: 'Guitar', art: 'the' },
        blue: { name: 'Drums', art: 'the' },
        green: { name: 'Keyboard', art: 'the' },
        yellow: { name: 'Trumpet', art: 'the' },
        wild: { name: 'Turntable', art: 'the' },
    },
    viruses: {
        red: 'Snapped String',
        blue: 'Broken Drumstick',
        green: 'Stuck Key',
        yellow: 'Sour Note',
        wild: 'Feedback',
    },
    medicines: {
        red: 'New Strings',
        blue: 'New Drumhead',
        green: 'Tuner',
        yellow: 'Mouthpiece',
        wild: 'Dress Rehearsal',
    },
    treatments: {
        swap: {
            name: 'Jam Session',
            text: 'Swap one of your instruments for one of another player\'s. Neither may be legendary, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Star Signing',
            text: 'One of another player\'s instruments jumps ship to your band. Does not work on legendary instruments, or if you already have one of that color.',
        },
        spread: {
            name: 'Echo',
            text: 'The noise from your instruments bounces around the room and lands on your rivals\' free instruments.',
        },
        quarantine: {
            name: 'Chorus of Boos',
            text: 'The crowd boos your rivals: they drop their hand and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Stage Swap',
            text: 'Swap your whole band with another player\'s, legendary instruments included.',
        },
    },
    hints: {
        organ: 'Bring it onto your stage. One of each color.',
        virus: 'Detunes a free instrument, wrecks a detuned one or undoes a tuning.',
        medicine: 'Fixes a detuned instrument, tunes a free one or makes a tuned one legendary.',
    },
    stamps: { infected: 'Off-key', vaccinated: 'Tuned', immunized: 'Legendary' },
    words: {
        organ: 'instrument',
        organs: 'instruments',
        the: 'the',
        one: 'one',
        healthy: 'gig-ready',
        threat: 'noise',
        threats: 'noises',
        body: 'band',
    },
    lines: {
        place: '{p} brings the {card} onto their stage.',
        infect: '{p} detunes {organ}.',
        remove: '{p} wrecks {organ}.',
        breakShield: '{p} throws off the tuning on {organ}.',
        cure: '{p} fixes {organ}.',
        vaccinate: '{p} tunes {organ}.',
        immunize: '{p} turns {organ} into a legend.',
        spread: '{p} bounces {n} {threats} toward their rivals.',
        quarantine: '{p} gets the crowd booing: everyone else drops their hand.',
        malpractice: '{p} swaps stages with {victim}: bands traded.',
        win: '{p} completes their band and wins the game.',
    },
    buttons: { spread: 'Bounce {n} {threats}', quarantine: 'Start the boos', malpractice: 'Swap stages' },
    ending: {
        winTitle: 'Band complete. You win.',
        winText: 'Four gig-ready instruments before anyone else.',
        loseTitle: '{p} completes their band.',
        loseText: 'Your band was left half assembled. The next round starts from scratch.',
    },
};
const PIRATAS_EN = {
    id: 'piratas',
    name: 'Pirates',
    tagline: 'One ship, one map and a crew that trusts no one.',
    kinds: { organ: 'Treasure', virus: 'Disaster', medicine: 'Remedy', treatment: 'Ruse' },
    organs: {
        red: { name: 'Parrot', art: 'the' },
        blue: { name: 'Ship', art: 'the' },
        green: { name: 'Map', art: 'the' },
        yellow: { name: 'Spyglass', art: 'the' },
        wild: { name: 'Island of Gold', art: 'the' },
    },
    viruses: {
        red: 'Mutiny',
        blue: 'Kraken',
        green: 'Scurvy',
        yellow: 'Fog',
        wild: 'Ghost Ship',
    },
    medicines: {
        red: 'Cracker',
        blue: 'New Sails',
        green: 'Lemons',
        yellow: 'Compass',
        wild: 'Loyal Crew',
    },
    treatments: {
        swap: {
            name: 'Dockside Barter',
            text: 'Swap one of your treasures for one of another player\'s. Neither may be buried, and nobody can end up with two of the same color.',
        },
        steal: {
            name: 'Boarding Party',
            text: 'Board another player and haul one of their treasures into your hold. Does not work on buried treasures, or if you already have one of that color.',
        },
        spread: {
            name: 'Broadside',
            text: 'Fire the disasters in your hold at your rivals\' free treasures.',
        },
        quarantine: {
            name: 'Storm',
            text: 'A storm throws your rivals\' hands overboard: they discard them and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Turncoat',
            text: 'Swap your whole hold with another player\'s, buried treasures included.',
        },
    },
    hints: {
        organ: 'Stow it in your hold. One of each color.',
        virus: 'Plunders a free treasure, sinks a plundered one or uncovers a hidden one.',
        medicine: 'Recovers a plundered treasure, hides a free one or buries a hidden one.',
    },
    stamps: { infected: 'Plundered', vaccinated: 'Hidden', immunized: 'Buried' },
    words: {
        organ: 'treasure',
        organs: 'treasures',
        the: 'the',
        one: 'one',
        healthy: 'shipshape',
        threat: 'disaster',
        threats: 'disasters',
        body: 'hold',
    },
    lines: {
        place: '{p} stows the {card} in their hold.',
        infect: '{p} plunders {organ}.',
        remove: '{p} sinks {organ}.',
        breakShield: '{p} finds the hiding spot of {organ}.',
        cure: '{p} recovers {organ}.',
        vaccinate: '{p} hides {organ}.',
        immunize: '{p} buries {organ}.',
        spread: '{p} fires {n} {threats} at their rivals.',
        quarantine: '{p} whips up a storm: everyone else loses their hand overboard.',
        malpractice: '{p} switches flags and seizes {victim}\'s hold.',
        win: '{p} fills their hold and wins the game.',
    },
    buttons: { spread: 'Fire {n} {threats}', quarantine: 'Unleash the storm', malpractice: 'Switch flags' },
    ending: {
        winTitle: 'Hold full. You win.',
        winText: 'Four shipshape treasures before anyone else.',
        loseTitle: '{p} fills their hold.',
        loseText: 'Your hold was left half empty. The next round starts from scratch.',
    },
};
const DEMA_EN = {
    id: 'dema',
    name: 'Dema',
    tagline: 'Nine bishops, a concrete wall and a color they cannot see.',
    kinds: { organ: 'Ally', virus: 'Bishop', medicine: 'Cover', treatment: 'Rite' },
    organs: {
        red: { name: 'Clancy', art: 'the' },
        blue: { name: 'Ned', art: 'the' },
        green: { name: 'Trash the Dragon', art: 'the' },
        yellow: { name: 'Torchbearer', art: 'the' },
        wild: { name: 'Vulture', art: 'the' },
    },
    viruses: {
        red: 'Sacarver',
        blue: 'Reisdro',
        green: 'Vetomo',
        yellow: 'Listo',
        wild: 'Nico',
    },
    medicines: {
        red: 'Bonfire',
        blue: 'Blue Door',
        green: 'Tunnel',
        yellow: 'Petals',
        wild: 'Sahlo Folina',
    },
    treatments: {
        swap: {
            name: 'Changing of the Guard',
            text: 'Swap one of your allies for another player\'s. Neither may be unseen, and nobody can end up with a repeated color.',
        },
        steal: {
            name: 'Defection',
            text: 'One of another player\'s allies defects and joins your camp. Does not work on unseen allies, or if you already have one of that color.',
        },
        spread: {
            name: 'The Niners',
            text: 'The bishops smearing your camp head out together to smear your rivals\' free allies.',
        },
        quarantine: {
            name: 'Glorious Assemblage',
            text: 'The city summons your rivals: they hand over their hand and lose their next turn drawing a new one.',
        },
        malpractice: {
            name: 'Seizing',
            text: 'Take over another player\'s camp and leave them yours, unseen allies included.',
        },
    },
    hints: {
        organ: 'Bring them into your camp. One of each color.',
        virus: 'Smears a free ally, carries off a smeared one or tears the tape from a taped one.',
        medicine: 'Cleans a smeared ally, tapes a free one or turns them unseen if they were already taped.',
    },
    stamps: { infected: 'Smeared', vaccinated: 'Taped', immunized: 'Unseen' },
    words: {
        organ: 'ally',
        organs: 'allies',
        the: 'the',
        one: 'one',
        healthy: 'safe',
        threat: 'bishop',
        threats: 'bishops',
        body: 'camp',
    },
    lines: {
        place: '{p} brings {card} into their camp.',
        infect: '{p} smears {organ}.',
        remove: '{p} carries off {organ}.',
        breakShield: '{p} tears the tape from {organ}.',
        cure: '{p} cleans {organ}.',
        vaccinate: '{p} tapes {organ} in yellow.',
        immunize: '{p} turns {organ} unseen.',
        spread: '{p} sends {n} {threats} after their rivals.',
        quarantine: '{p} calls the assemblage: everyone else hands over their hand.',
        malpractice: '{p} seizes {victim} and takes over their camp.',
        win: '{p} gathers their own and wins the game.',
    },
    buttons: { spread: 'Send {n} {threats}', quarantine: 'Call the assemblage', malpractice: 'Seize a camp' },
    ending: {
        winTitle: 'Camp complete. You win.',
        winText: 'Four safe allies before anyone else. East is up.',
        loseTitle: '{p} completes their camp.',
        loseText: 'Your camp was left half empty. The wall is still standing.',
    },
    credit: 'The world of Dema, its bishops, Clancy, Torchbearer, Ned and Trash the Dragon belong to Twenty One Pilots; this pack is a non-profit fan tribute.',
};
export const PACKS_EN = {
    contagio: CONTAGIO_EN,
    heroes: HEROES_EN,
    marvel: MARVEL_EN,
    frutas: FRUTAS_EN,
    cortafuegos: CORTAFUEGOS_EN,
    orbita: ORBITA_EN,
    asedio: ASEDIO_EN,
    arrecife: ARRECIFE_EN,
    grimorio: GRIMORIO_EN,
    jurasico: JURASICO_EN,
    banda: BANDA_EN,
    piratas: PIRATAS_EN,
    dema: DEMA_EN,
};
//# sourceMappingURL=packs-en.js.map